const packageVersion = "v7.10.0";
export {
  packageVersion
};
//# sourceMappingURL=packageVersion.js.map
